import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { isAuthenticated } from '../lib/auth'

/**
 * `_auth` - the pathless layout for unauthenticated pages (login, signup). These
 * render without the cockpit shell. In mock mode any credential passes; the real
 * Cognito flow is PLAN-02.
 */
export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    if (isAuthenticated()) throw redirect({ to: '/' })
  },
  component: AuthLayout,
})

function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--hostingportal-chrome-bg)] p-6">
      <Outlet />
    </div>
  )
}
